import { useContext, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router-dom';

import { Link } from '../../components/link/Link';
import { AuthContext } from '../../context/auth-context';
import UserBgImg from '../header/images/profile_1.png';

export function ProfileLinkButton() {
  const { t } = useTranslation();
  const [profileImage, setProfileImage] = useState(UserBgImg);
  const auth = useContext(AuthContext);

  const { pathname } = useLocation();
  const isProfilePage = pathname.includes('/profile');

  useEffect(() => {
    if (auth.image) {
      setProfileImage(auth.image);
    }
  }, [auth.image]);

  return auth.isLoggedIn ? (
    <div className="profile-link-button">
      <Link
        href="/profile/settings"
        ariaCurrent={isProfilePage ? 'page' : undefined}
        className={isProfilePage ? 'no-cursor-actions' : undefined}
      >
        <span className="visuallyHidden">{t('nav.page.profileUpdate')}</span>
        <div>
          <img
            id="photo-outer"
            src={profileImage}
            alt=""
            className={`profile-link-button-image fs-exclude ${isProfilePage ? 'active' : ''}`}
          />
        </div>
      </Link>
    </div>
  ) : undefined;
}
